import { Container, Grid, Typography } from '@mui/material';
import { Header } from 'components/Header/Header';
import './styles.css';

export const Terms = () => {
  return (
    <Grid>
      <Header />
      <Grid>
        <Typography
          variant='h3'
          textAlign={'center'}
        >
          Terms and Conditions
        </Typography>

        <Grid>
          <Typography
            variant={'body1'}
            textAlign={'center'}
          >
      
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );//TODO External Microservice Dynamic content for the Terms , Configurable from WYSIWIG Editor
};
